import Joi from "joi";

export const assetStatusesSchema = Joi.object({
  title: Joi.string().min(2).label("Title"),
  badgeColor: Joi.string().min(2).label("Color"),
  // isDefault: Joi.boolean().label("Is Default"),
});
